export enum AccountType {
  Admin = 0,
  County = 1,
  TaxPayer = 2,
  Legal = 3,
}
